<template>

    <div class="list-view-scroller">
        <slot></slot>
    </div>

</template>

<style lang="scss">
    div.list-view-scroller {
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;


        h2 {
            margin: 5px 0 5px;
            font-size: 1.15em;
            color: #659dba;
            clear: both;
        }
        ul {
            margin-bottom: 30px;
            a {
                color: $brand;
                text-decoration: none;
            }
        }
    }

</style>

<script>
    export default {
        data() {
            return {}
        },
        watch: {},
        computed: {
            name() {
                return this.$parent.name;
            }
        },
        methods: {},
        mounted() {
        }
    }
</script>   
